import { combineReducers } from "redux";
import { userReducer } from "./userReducer";
import { participantesReducer } from "./participanteReducer";
import { cambiarPestañaReducer, convocatoriasReducer, edicionReducer } from "./convocatoriasReducer";
import { idjuradosReducer,  } from "./juradosReducer";

export const reducer = combineReducers({
  user: userReducer,
  convocatoria: convocatoriasReducer,
  participantes: participantesReducer,
  edicion: edicionReducer,
  jurado: idjuradosReducer,
  cambiarPestaña: cambiarPestañaReducer,
});

export type RootState = ReturnType<typeof reducer>